import Svg, { Path } from 'react-native-svg';

export const AblyIcon = () => {
  return (
    <Svg width={36} height={36} viewBox="0 0 36 37" fill="none">
      <Path
        d="M28.8 0.5H7.2C3.22355 0.5 0 3.72355 0 7.7V29.3C0 33.2765 3.22355 36.5 7.2 36.5H28.8C32.7765 36.5 36 33.2765 36 29.3V7.7C36 3.72355 32.7765 0.5 28.8 0.5Z"
        fill="white"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.49877 15.6875L4.14844 21.2894H5.44039L5.94625 20.0794H8.22651L8.73248 21.2894H10.0244L7.67399 15.6875H6.49877ZM7.09024 17.3545L7.7674 18.9814H6.40547L7.09024 17.3545Z"
        fill="#1F1F1F"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.4138 15.6875V21.2894H24.6048V20.1755H21.6986V15.6875H20.4138Z"
        fill="#1F1F1F"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30.4598 15.6875L29.2162 17.7713L27.9727 15.6875H26.5809L28.5739 19.0775V21.2894H29.8586V19.0775L31.8515 15.6875H30.4598Z"
        fill="#1F1F1F"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.9093 19.1032V19.1035H15.2324C15.5622 19.1035 15.8852 19.3756 15.8852 19.7082V19.7286C15.8852 20.0611 15.5622 20.3333 15.2324 20.3333H14.9093V20.3335H13.8996V19.1032H14.9093ZM14.914 16.6525V16.6528H15.0311C15.3608 16.6528 15.6306 16.9248 15.6306 17.2575V17.2778C15.6306 17.6104 15.3608 17.8826 15.0311 17.8826H14.914V17.8827H13.8996V16.6525H14.914ZM12.5998 21.2895L14.0635 21.2898H14.0705L15.8303 21.2902C16.579 21.2902 17.1908 20.6748 17.1908 19.9195V19.6994C17.1908 19.0453 16.7309 18.4948 16.1213 18.3591C16.1173 18.3582 16.1135 18.3569 16.1095 18.3561C16.1279 18.35 16.1614 18.3424 16.181 18.3357C16.9839 18.0747 16.9018 17.1044 16.9018 17.1044C16.9018 16.3482 16.2056 15.728 15.4627 15.6995L14.0788 15.696L14.0694 15.6962L12.5989 15.6958L12.5998 21.2895Z"
        fill="#1F1F1F"
      />
    </Svg>
  );
};
